/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as LegalRouteImport } from './routes/legal'
import { Route as IndexRouteImport } from './routes/index'
import { Route as VulglanceIndexRouteImport } from './routes/vulglance/index'
import { Route as AutoVideoCreatorIndexRouteImport } from './routes/auto-video-creator/index'
import { Route as VulglanceTermsRouteImport } from './routes/vulglance/terms'

const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const LegalRoute = LegalRouteImport.update({
  id: '/legal',
  path: '/legal',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const VulglanceIndexRoute = VulglanceIndexRouteImport.update({
  id: '/vulglance/',
  path: '/vulglance/',
  getParentRoute: () => rootRouteImport,
} as any)
const AutoVideoCreatorIndexRoute = AutoVideoCreatorIndexRouteImport.update({
  id: '/auto-video-creator/',
  path: '/auto-video-creator/',
  getParentRoute: () => rootRouteImport,
} as any)
const VulglanceTermsRoute = VulglanceTermsRouteImport.update({
  id: '/vulglance/terms',
  path: '/vulglance/terms',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/legal': typeof LegalRoute
  '/privacy': typeof PrivacyRoute
  '/vulglance/terms': typeof VulglanceTermsRoute
  '/auto-video-creator/': typeof AutoVideoCreatorIndexRoute
  '/vulglance/': typeof VulglanceIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/legal': typeof LegalRoute
  '/privacy': typeof PrivacyRoute
  '/vulglance/terms': typeof VulglanceTermsRoute
  '/auto-video-creator': typeof AutoVideoCreatorIndexRoute
  '/vulglance': typeof VulglanceIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/legal': typeof LegalRoute
  '/privacy': typeof PrivacyRoute
  '/vulglance/terms': typeof VulglanceTermsRoute
  '/auto-video-creator/': typeof AutoVideoCreatorIndexRoute
  '/vulglance/': typeof VulglanceIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/legal'
    | '/privacy'
    | '/vulglance/terms'
    | '/auto-video-creator/'
    | '/vulglance/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/legal'
    | '/privacy'
    | '/vulglance/terms'
    | '/auto-video-creator'
    | '/vulglance'
  id:
    | '__root__'
    | '/'
    | '/legal'
    | '/privacy'
    | '/vulglance/terms'
    | '/auto-video-creator/'
    | '/vulglance/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  LegalRoute: typeof LegalRoute
  PrivacyRoute: typeof PrivacyRoute
  VulglanceTermsRoute: typeof VulglanceTermsRoute
  AutoVideoCreatorIndexRoute: typeof AutoVideoCreatorIndexRoute
  VulglanceIndexRoute: typeof VulglanceIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/legal': {
      id: '/legal'
      path: '/legal'
      fullPath: '/legal'
      preLoaderRoute: typeof LegalRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/vulglance/': {
      id: '/vulglance/'
      path: '/vulglance'
      fullPath: '/vulglance/'
      preLoaderRoute: typeof VulglanceIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auto-video-creator/': {
      id: '/auto-video-creator/'
      path: '/auto-video-creator'
      fullPath: '/auto-video-creator/'
      preLoaderRoute: typeof AutoVideoCreatorIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/vulglance/terms': {
      id: '/vulglance/terms'
      path: '/vulglance/terms'
      fullPath: '/vulglance/terms'
      preLoaderRoute: typeof VulglanceTermsRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LegalRoute: LegalRoute,
  PrivacyRoute: PrivacyRoute,
  VulglanceTermsRoute: VulglanceTermsRoute,
  AutoVideoCreatorIndexRoute: AutoVideoCreatorIndexRoute,
  VulglanceIndexRoute: VulglanceIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
